<template>
  <div class="insights-adsets-table">
    <a-g-speakol-table ref="adsetsTable" :columns="agColumns" :filters="agFilters" :options="agOptions" :perPageDefault="25"></a-g-speakol-table>

    <speakol-response-popup
      v-on:hide-response-popup="stateModal.show = false"
      :responsePopupData="stateModal"
    />
  </div>
</template>

<script>
// import SpeakolTable from '@/components/SpeakolTable.vue'
import AGSpeakolTable from '@/components/AGSpeakolTable'

import { Server, DataSource } from '@/datasources/DataSource'

import ToggleAdsetOrAdStatus from '@/views/campaigns/insights/components/_content_partials/_tables_partials/_ag_custom_cells/ToggleAdsetOrAdStatus.vue'
import AdsetOrAdName from '@/views/campaigns/insights/components/_content_partials/_tables_partials/_ag_custom_cells/AdsetOrAdName.vue'
import StatusComponent from '@/views/campaigns/insights/components/_content_partials/_tables_partials/_ag_custom_cells/StatusComponent.vue'
import BidColumn from '@/views/campaigns/insights/components/_content_partials/_tables_partials/_ag_custom_cells/AdsetBidColumn.vue'
import DailyBudgetColumn from '@/views/campaigns/insights/components/_content_partials/_tables_partials/_ag_custom_cells/DailyBudgetColumn.vue'
export default {
  props: {
    filters: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    },
    campaignType: {
      type: String,
      required: true
    },
    campaignBudgetType: {
      type: String,
      required: true
    },
    pixelEvent: {
      type: String,
      default: 'conversions',
      required: false
    }
  },
  components: {
    AGSpeakolTable,
    ToggleAdsetOrAdStatus,
    AdsetOrAdName,
    StatusComponent,
    BidColumn,
    DailyBudgetColumn,
    EditButton: {
      template: `
        <vs-button
          id="insights-table-adsets-edit-button"
          class="px-3 py-2"
          size="small"
          type="border"
          @click="$router.push({
            name: 'campaigns-edit',
            params: {
              id: params.data.campaign_id
            },
            query: {
              step: 3,
              adset: params.data.id
            }
          })"
        >
          <vs-icon icon-pack="speakol" icon="speakol-edit" svgClasses="w-5 h-5"/>
        </vs-button>
      `
    }
  },
  data () {
    return {
      stateModal: {
        type: 'error',
        show: false,
        body: 'Error message'
      },
      agFilters: this.getAgFilters(),
      agOptions: {
        rowHeight: 80,
        context: {
          parent: this
        },
        dataSource: DataSource(
          Server(`/campaigns/${this.$route.params.id}/insights/adsets`)
        ),

        // for setting default group column def
        autoGroupColumnDef: {
          headerName: '',
          headerTooltip: '',
          minWidth: 50,
          maxWidth: 50,
          resizable: false,
          valueGetter () {
            return ''
          }
        },

        // enable Tree Data
        treeData: true,
        // indicate if row is a group node
        isServerSideGroup (dataItem) {
          // eslint-disable-next-line
          return !!dataItem.children_count;
        },
        // specify which group key to use
        getServerSideGroupKey (dataItem) {
          return dataItem.id
        },
        paginateChildRows: true
      },
      agColumns: this.getAgColumns()
    }
  },
  mounted () {
    this.$root.$on('changed:campaign-status', () => {
      this.applyFilters()
    })
  },
  methods: {
    getAgColumns () {
      const self = this

      const columns = [
        {
          headerName: this.$t(''),
          headerTooltip: this.$t('Activate/Deactivate'),
          field: 'change-status',
          minWidth: 79,
          maxWidth: 79,
          resizable: false,
          cellRendererFramework: 'ToggleAdsetOrAdStatus'
        },
        {
          headerName: 'Adset/Ad',
          headerTooltip: 'Adset/Ad Name',
          cellRendererFramework: 'AdsetOrAdName',
          autoHeight: true,
          minWidth: 235
        },
        {
          headerName: 'Status',
          field: 'aggregated_status',
          cellRendererFramework: 'StatusComponent',
          minWidth: 165
        },
        {
          headerName: this.campaignBudgetType,
          minWidth: 230,
          field: 'budget',
          cellRendererFramework: 'DailyBudgetColumn'
        },
        {
          headerName: 'Bid',
          field : 'max_bid_price',
          minWidth: 250,
          cellRendererFramework: 'BidColumn'
        },
        {
          headerName: this.$t('Impressions'),
          headerTooltip: this.$t('Imp.'),
          minWidth: 162,
          field: 'impressions',
          valueGetter (params) {
            return self.$options.filters.addComma(((params.data || {}).analytics || {}).impressions || 0)
          }
        },
        {
          headerName: this.$t('Clicks'),
          headerTooltip: this.$t('Clicks'),
          field: 'clicks',
          minWidth: 110,
          valueGetter (params) {
            return self.$options.filters.addComma(((params.data || {}).analytics || {}).clicks || 0)
          }
        },
        {
          headerName: this.$t('CTR'),
          headerTooltip: this.$t('CTR'),
          field: 'ctr',
          minWidth: 95,
          valueGetter (params) {
            return `${parseFloat(((params.data || {}).analytics || {}).ctr || '0').toFixed(2)}%`
          }
        },
        {
          headerName: this.$t('Avg. CPC'),
          headerTooltip: this.$t('AVR.CPC'),
          minWidth: 135,
          field: 'average_cpc',
          valueGetter (params) {
            return self.$options.filters.addComma(parseFloat(((params.data || {}).analytics || {}).average_cpc || 0).toFixed(2), '$')
          }
        }
      ]

      if (this.campaignType === 'Video' || this.campaignType === 'Stories') {
        const videoCols = ['video_views', 'video_starts', 'video_first_quarters', 'video_midpoints', 'video_third_quarters', 'video_completes', 'video_repeats']
        videoCols.forEach(col => {
          columns.push({
            headerName: this.$t(col),
            headerTooltip: this.$t(col),
            field: col,
            minWidth: 210,
            valueGetter (params) {
              return self.$options.filters.addComma(((params.data || {}).analytics || {})[col] || 0)
            }
          })
        })
      }

      const pixelEvent = this.$t((this.pixelEvent === 'total' ? 'Conversions' : this.pixelEvent) || 'Conversions')

      columns.push(...[
        {
          headerName: pixelEvent,
          headerTooltip: pixelEvent,
          field: 'filter_event',
          minWidth:200,
          valueGetter (params) {
            return self.$options.filters.addComma((params.data || {}).filter_event || 0)
          }
        },
        {
          headerName: this.$t('CPA'),
          headerTooltip: this.$t('CPA'),
          field: 'filter_cpa',
          minWidth: 110,
          valueGetter (params) {
            return self.$options.filters.addComma((params.data || {}).filter_cpa || 0, '$')
          }
        }
      ])

      columns.push({
        headerName: this.$t('Spent'),
        headerTooltip: this.$t('Spent'),
        field: 'spent',
        minWidth: 110,
        valueGetter (params) {
          return self.$options.filters.addComma(((params.data || {}).analytics || {}).spent || 0, '$')
        }
      })

      if (this.$canAny('edit_personal_campaigns', 'edit_all_campaigns')) {
        columns.push({
          headerName: this.$t('Actions'),
          headerTooltip: this.$t('Edit'),
          field: 'edit',
          minWidth: 100,
          resizable: false,
          cellRendererFramework: 'EditButton'
        })
      }

      return columns.map(c => {
        if (!c.hasOwnProperty('minWidth')) {
          c.minWidth = 120
        }
        return c
      })
    },
    getAgFilters () {
      return {
        // eslint-disable-next-line
        adset: !!this.filters.adset ? this.filters.adset : null,
        pixelEvent: this.pixelEvent || 'conversions',
        from_date: this.filters.dateRange.startDate,
        to_date: this.filters.dateRange.endDate
      }
    },
    applyFilters () {
      /**
       * update filters state
       */
      // eslint-disable-next-line
      this.agFilters.adset = !!this.filters.adset ? this.filters.adset : null
      this.agFilters.pixelEvent = this.pixelEvent || 'conversions'
      this.agFilters.from_date = this.filters.dateRange.startDate
      this.agFilters.to_date = this.filters.dateRange.endDate


      // update columns
      this.agColumns = this.getAgColumns()

      if (this.$refs['adsetsTable']) {
        this.$refs['adsetsTable'].setColumnDefs([])
        this.$refs['adsetsTable'].setColumnDefs(this.agColumns)
        this.$refs['adsetsTable'].applyFilters()
      }
    }
  }
}
</script>

<style lang="scss">

  .icon-rotate-90deg {
    transform: rotate(90deg);
  };

  .insights-adsets-table {
    .vs-icon {
      font-size: 12px !important;
    }

    .vs-switch-primary {
      background-color: #d80027 !important;
    }

    .vs-switch-active {
      background-color: #009bde !important;
    }

    .vs-switch:disabled {
      background-color: #e2e2e2 !important;
    }
  }

  .insights-adsets-table .vs-icon {
    font-size: 16px !important;
  }
</style>
